import { UserMessageType } from '#/types/message';
import styles from './user-message.module.css';

interface UserMessageProps {
  message: UserMessageType;
  isExhibitionMode?: boolean;
}

function stripSeconds(ts?: string) {
  if (!ts) return '';
  // If it looks like "HH:MM:SS", return "HH:MM"
  const m = ts.match(/^(\d{1,2}:\d{2})/);
  return m ? m[1] : ts; // fallback unchanged if unexpected format
}

function UserMessage({ message, isExhibitionMode }: UserMessageProps) {
  return (
    <div
      className={styles.userMessageContainer}
      style={{ display: message.text.length > 0 ? "block" : "none" }}
    >
      <div className={styles.userMessageBubble}>
        <div id="userMessage" className={styles.userMessage}>
          {message.text}
        </div>
      </div>
      <div className={styles.timestamp}>
        {isExhibitionMode ? stripSeconds(message.timestamp) : message.timestamp}
      </div>
    </div>
  );
}


export default UserMessage;